import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["iconPlaceholder", "logoPlaceholder"]

  connect() {
    this.initializeColorPickers()
    this.initializeExistingImages()
    this.setupHoverEffects()
    this.setupTurboStreamHandlers()
  }
  
  initializeExistingImages() {
    document.querySelectorAll('.preview-image').forEach(img => {
      if (img.src && img.src !== window.location.href && !img.src.endsWith('/')) {
        img.style.display = 'block'
        const container = img.closest('.avatar, .logo')
        if (container) {
          const placeholder = container.querySelector('.no-photo')
          if (placeholder) {
            placeholder.style.display = 'none'
          }
        }
      } else {
        // No image, ensure placeholder is visible
        img.style.display = 'none'
        const container = img.closest('.avatar, .logo')
        if (container) {
          const placeholder = container.querySelector('.no-photo')
          if (placeholder) {
            placeholder.style.display = 'block'
          }
        }
      }
    })
  }
  
  setupHoverEffects() {
    // Add CSS for hovering only delete buttons
    const style = document.createElement('style')
    style.textContent = `
      .avatar .delete-btn, .logo .delete-btn {
        opacity: 0;
        visibility: hidden;
        transition: opacity 0.2s ease-in-out, visibility 0.2s ease-in-out;
      }
      
      .avatar:hover .delete-btn, .logo:hover .delete-btn {
        opacity: 1;
        visibility: visible;
      }
    `
    document.head.appendChild(style)
  }
  
  setupTurboStreamHandlers() {
    // Listen for Turbo Stream updates to reinitialize after image deletion
    document.addEventListener('turbo:before-stream-render', (event) => {
      if (event.target && event.target.querySelector('#branding')) {
        // Small delay to let the DOM update
        setTimeout(() => {
          this.initializeExistingImages()
        }, 100)
      }
    })
  }

  initializeColorPickers() {
    document.querySelectorAll('.color-box').forEach(box => {
      const colorInput = box.querySelector('input[type="color"]')
      const textInput = box.querySelector('input[type="text"]')
      
      // Set initial text input value from color input if it exists
      if (colorInput.value) {
        textInput.value = colorInput.value
      }
      // Or set color input from text input if that exists
      else if (textInput.value && /^#[0-9A-F]{6}$/i.test(textInput.value)) {
        colorInput.value = textInput.value
      }

      colorInput.addEventListener('input', (e) => {
        textInput.value = e.target.value
      })

      textInput.addEventListener('input', (e) => {
        const value = e.target.value
        if (/^#[0-9A-F]{6}$/i.test(value)) {
          colorInput.value = value
        }
      })
    })
  }

  previewIcon(event) {
    this.handleFileUpload(event, "icon")
  }

  previewLogo(event) {
    this.handleFileUpload(event, "logo")
  }

  handleFileUpload(event, type) {
    const file = event.target.files[0]
    const maxSize = parseInt(event.target.dataset.maxFileSize)

    if (!file) return

    // Check file size
    if (file.size > maxSize) {
      alert(`File size must be less than ${maxSize / 1024}KB`)
      event.target.value = ""
      return
    }

    // Check file type
    if (!['image/jpeg', 'image/png'].includes(file.type)) {
      alert('Only JPG and PNG files are allowed')
      event.target.value = ""
      return
    }

    // Preview image
    const reader = new FileReader()
    const previewImage = event.target.nextElementSibling
    const placeholder = type === 'icon' ? this.iconPlaceholderTarget : this.logoPlaceholderTarget

    reader.onload = (e) => {
      previewImage.src = e.target.result
      previewImage.style.display = 'block'
      placeholder.style.display = 'none'
    }

    reader.readAsDataURL(file)
  }
}